(function () {
  function bumpCartIcon() {
    var cartIcon = document.getElementById('cart-icon-bubble');
    if (!cartIcon) return;

    cartIcon.classList.remove('cart-icon-bump');
    // Force reflow so the animation restarts even if triggered again quickly
    void cartIcon.offsetWidth;
    cartIcon.classList.add('cart-icon-bump');

    cartIcon.addEventListener(
      'animationend',
      function () {
        cartIcon.classList.remove('cart-icon-bump');
      },
      { once: true }
    );
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (data) {
      if (data && data.source === 'product-form') {
        bumpCartIcon();
      }
    });
  }
})();
